import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Card, Modal, CardBody, Button, Label, Input, Form, TabPane, TabContent, FormFeedback } from "reactstrap";

import Select from "react-select";
import ReactFlagsSelect from "react-flags-select";

import { withRouter, Link } from "react-router-dom";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

//Import Breadcrumb
import Breadcrumb from "../../components/Common/Breadcrumb";
import { checkFileValidation } from "../../Utils/Common";

// actions
import "../../assets/scss/custom/style.css";

import Autocomplete from '@material-ui/lab/Autocomplete';
import Box from '@material-ui/core/Box';
import { TextField } from '@material-ui/core';
import Snackbars from "../../Utils/Snackbars";
import useRequests from '../../Utils/useRequests';
import i18next from 'i18next';
import { formatCurrency, formatDate, formatStatus } from '../../Utils/formatters';
import moment from 'moment';

const colourStyles = {
  menuList: styles => ({
    ...styles,
    background: '#ffffff',
  }),
  option: (styles, { isFocused, isSelected, isDisabled }) => ({
    ...styles,
    background: isFocused
      ? '#036B41'
      : isSelected
        ? isSelected
          ? "#036B41"
          : "#000"
        : undefined,
    zIndex: 1,
    color: isFocused
      ? '#fff'
      : isSelected
        ? isSelected
          ? "#F7F7FA"
          : "#000"
        : undefined,
    ':active': {
      ...styles[':active'],
      backgroundColor: !isDisabled
        ? isSelected
          ? "#fff"
          : "#036B41"
        : undefined,
    },
  }),
  menu: base => ({
    ...base,
    zIndex: 100,
  }),
}

const UserProfile = () => {
  //meta title
  document.title = i18next.t('Profile PG document title');
  const { getRequest, postRequest, postRequestByFormData } = useRequests();
  // Step 2.2 — marketing consent toggle state
  const [marketingConsent, setMarketingConsent] = React.useState(false);
  const [consentLoading, setConsentLoading] = React.useState(false);
  const inputRef = useRef(null)

  const [modal_MobileVerification, setmodal_MobileVerification] = useState(false);
  function MobileVerification() {
    setmodal_MobileVerification(!modal_MobileVerification);
  }

  const refreshPage = () => {
    window.location.reload();
  };



  const [AlertData, setAlertData] = React.useState({
		variant: '',
		message: '',
	});
	const resetAlertData = () => {
		setTimeout(() => {
			setAlertData((AlertData) => ({
				...AlertData,
				variant: '',
				message: '',
			}));
		}, 5000);
	};


  const [formData1, setFormData1] = React.useState({
		country: {label: 'Spain', value: 'Spain'},
	});

  const [formData4, setFormData4] = React.useState({
		tax_residency: {label: 'Spain', value: 'Spain'},
	});

  const [formData2, setFormData2] = React.useState({
		country_code: 'ES',
	});
  const [CustomError1, setCustomError1] = React.useState({
		country: '',
    PreferredLanguage: '',
	});
  const [CustomError2, setCustomError2] = React.useState({
    country_code: '',
	});

  const [CustomError4, setCustomError4] = React.useState({
		tax_residency: '',
	});

  const validation1 = useFormik({
    enableReinitialize: true,

    initialValues: {
      first_name: '',
      last_name: '',
      email: '',
    },
    validationSchema: Yup.object({
      first_name: Yup.string()
        .required(i18next.t('Profile PG First Name is required')),
      last_name: Yup.string()
        .required(i18next.t('Profile PG Last Name is required')),
    }),
    onSubmit: async (values) => {
      try {
        setCustomError1({
          ...CustomError1,
          country: '',
          PreferredLanguage: '',
        });

        if (formData1.country === null) {
          setCustomError1({
						...CustomError1,
						country: i18next.t('Profile PG Please select country'),
					});
        } else if (PreferredLanguage === null) {
          setCustomError1({
						...CustomError1,
						PreferredLanguage: i18next.t('Profile PG Please select preferred language'),
					});
        } else {
          let submit1 = document.getElementById('submit1');
          submit1.disabled = true;
          submit1.textContent = i18next.t('Processing...');

          const jsonpar = JSON.stringify({
            first_name: values.first_name,
            last_name: values.last_name,
            country: formData1.country.value,
            preferred_language: PreferredLanguage,
          });
          const res = await postRequest('update-profile', jsonpar);
          if (res && res.code === 200) {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
          }
          else {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();

          submit1.disabled = false;
          submit1.textContent = i18next.t('Profile PG Update Profile');
        }
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });
  
  const validation2 = useFormik({
    enableReinitialize: true,

    initialValues: {
      phone: '',
    },
    validationSchema: Yup.object({
        phone: Yup.string()
        .matches(
            /^[#0-9]+$/,
            i18next.t('Please enter a valid profile pg mobile number!')
        )
        .required(i18next.t('Profile PG Mobile Number is required'))
        .test(
            'len',
            i18next.t('Phone numbers should not be greater than 10 digits!'),
            function (value) {
                return value ? value.length <= 10 : false; // Ensure the number is not greater than 10 digits
            }
        )
        .test(
          'not-same',
          i18next.t('Phone number cannot be the same as the current phone number!'),
          function (value) {
            const currentPhone = Phone; 
            const currentCountryCode = CountryCode; 
            const selectedCountryCode = formData2.country_code;
            return value !== currentPhone || selectedCountryCode !== currentCountryCode;
          }
        ),
    }),
    onSubmit: async (values) => {
      
      try{
        setCustomError2({
          ...CustomError2,
          country_code: '',
        });

        if (formData2.country_code === null) {
          setCustomError2({
            ...CustomError2,
            country_code: i18next.t('Profile PG Please select country code'),
          });
        } else {
          let temp_country_code = AllCountriesCustomData.find(element => element.code === formData2.country_code);

          const jsonpar = JSON.stringify({
            country_code: temp_country_code.phone_code,
            phone: values.phone
          });
          const res = await postRequest('profile-send-phone-otp', jsonpar)
          if (res && res.code === 200) {
            setAlertData(AlertData => ({
              ...AlertData,
              variant: 'success',
              message:  i18next.t('Email_Verification PG phone updated and sent OTP'),
            }))
            setmodal_MobileVerification(!modal_MobileVerification);
          } else {
            setAlertData(AlertData => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }))
          }
          resetAlertData()
      }
      }catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  const validation4 = useFormik({
    enableReinitialize: true,

    initialValues: {
      tax_id: '',
      date_of_birth: "",
      address: "",
      building: "",
      floor: "",
      street: "",
      city: "",
      state: "",
      postal_code: "",
      country: "",
    },
    validationSchema: Yup.object({
     tax_id: Yup.string()
      .required(i18next.t("Register PG Tax Id is required")),
      date_of_birth: Yup.date()
              .required(i18next.t("Date of Birth is required"))
              .max(
                new Date(new Date().setFullYear(new Date().getFullYear() - 18)),
                i18next.t("You must be at least 18 years old"),
              ),
      address: Yup.string().required(
        i18next.t("Register PG Address is required"),
      ),
    }),
    onSubmit: async (values) => {
      try {
        setCustomError4({
          ...CustomError4,
          tax_residency: '',
        });

        if (formData4.tax_residency === null) {
          setCustomError1({
						...CustomError1,
						tax_residency: i18next.t('Profile PG Please select country'),
					});
        } else {
          let submit4 = document.getElementById('submit4');
          submit4.disabled = true;
          submit4.textContent = i18next.t('Processing...');

          const jsonpar = JSON.stringify({
            tax_id: values.tax_id,
            tax_residency: formData4.tax_residency.value,
            date_of_birth: values.date_of_birth,
            address: values.address,
            building: values.building,
            floor: values.floor,
            street: values.street,
            city: values.city,
            state: values.state,
            postal_code: values.postal_code,
            country: values.country,
          });
          const res = await postRequest('update-profile-tax-info', jsonpar);
          if (res && res.code === 200) {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
          }
          else {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();

          submit4.disabled = false;
          submit4.textContent = i18next.t('Profile PG Update Profile');
        }
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });

  // const [AllCountriesData, setAllCountriesData] = React.useState([]);
  const [AllCountriesCustomData, setAllCountriesCustomData] = React.useState([]);
  const [AllCountriesCustomData2, setAllCountriesCustomData2] = React.useState([]);
  const handleLoadGetAllCountries = async () => {
    const res = await getRequest('get-all-countries');
    if (res && res.code === 200) {
      let originalText = res.data;

      let tempArr = [];
      originalText.forEach(element => {
        let temp = {
            label: element.country_name,
            value: element.country_name,
        };
        tempArr.push(temp);
      });
      tempArr = [{
          options: tempArr
      }];
      setAllCountriesCustomData2(tempArr);

      tempArr = [];
      originalText.forEach(element => {
        let temp = {
            code: element.country_code,
            label: element.country_code + ' +' + element.phone_code,
            phone_code: element.phone_code,
        };
        tempArr.push(temp);
      });
      setAllCountriesCustomData(tempArr);

      handleLoadGetUserInfo(originalText);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }
  
  const [CountryCode, setCountryCode] = React.useState(0)
  const [Phone, setPhone] = React.useState(0)

  const handleLoadGetUserInfo = async (TempAllCountriesCustomData) => {
    const res = await getRequest('get-user-info');
    if (res && res.code === 200) {
      let originalText = res.data;

      if(!originalText.tax_residency && !originalText.tax_id){
        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: i18next.t('Please complete tax information')
        }));
      }

      validation1.setValues({
        ...validation1.values,
        first_name: originalText.first_name,
        last_name: originalText.last_name,
        email: originalText.email,
      });
      setFormData1({ ...formData1, country: {label: originalText.country, value: originalText.country} });

      validation2.setValues({
        ...validation2.values,
        phone: originalText.phone,
      });
      let temp_country_code = TempAllCountriesCustomData.find(element => element.phone_code === originalText.country_code);
      setFormData2({ ...formData2, country_code: temp_country_code.country_code });

      // HTML <input type="date"> requires the value in YYYY-MM-DD format,
      // not the display format (DD/MM/YYYY) produced by formatDate().
      const formattedDate = originalText.date_of_birth
        ? moment(originalText.date_of_birth).format("YYYY-MM-DD")
        : "";
      validation4.setValues({
        ...validation4.values,
        tax_id: originalText.tax_id,
        date_of_birth: formattedDate,
        address: originalText.address,
        building: originalText.building || "",
        floor: originalText.floor || "",
      });
      setFormData4({ ...formData4, tax_residency: {label: originalText.tax_residency?originalText.tax_residency:originalText.country, value: originalText.tax_residency?originalText.tax_residency:originalText.country} });

      setPreferredLanguage(originalText.preferred_language);
      setCountryCode(temp_country_code.country_code);
      setPhone(originalText.phone);
      // Step 2.2 — pre-fill consent toggle from DB value
      setMarketingConsent(originalText.email_marketing_consent === true);
    }
    else {
      setAlertData((AlertData) => ({
        ...AlertData,
        variant: 'error',
        message: res.message,
      }));
    }
    resetAlertData();
  }

  // Step 2.2 — toggle marketing consent and sync to Segment/Mailchimp
  const handleConsentToggle = async (newValue) => {
    setConsentLoading(true);
    try {
      const jsonpar = JSON.stringify({ email_marketing_consent: newValue });
      const res = await postRequest('update-marketing-consent', jsonpar);
      if (res && res.code === 200) {
        setMarketingConsent(newValue);
        setAlertData(AlertData => ({
          ...AlertData,
          variant: 'success',
          message: res.message,
        }));
      } else {
        setAlertData(AlertData => ({
          ...AlertData,
          variant: 'error',
          message: res.message,
        }));
      }
    } catch (error) {
      console.error('handleConsentToggle error:', error);
    }
    setConsentLoading(false);
    resetAlertData();
  };

  const validation3 = useFormik({
    enableReinitialize: true,

    initialValues: {
      phone_otp: '',
    },
    validationSchema: Yup.object({
      phone_otp: Yup.string()
        .matches(/^[#0-9]+$/, i18next.t('Please enter a valid profile pg mobile number!'))
        .required(i18next.t('Email_Verification PG Phone OTP is required'))
        .min(
          6,
          i18next.t('Email_Verification PG Phone OTP should be 6 digits!'),
        )
        .max(
          6,
          i18next.t('Email_Verification PG Phone OTP should be 6 digits!'),
        ),
    }),
    onSubmit: async values => {

      try {
        let submit3 = document.getElementById('submit3')
        submit3.disabled = true
        submit3.textContent = i18next.t('Processing...')

     try {
        setCustomError2({
          ...CustomError2,
          country_code: '',
        });

        if (formData2.country_code === null) {
          setCustomError2({
						...CustomError2,
						country_code: i18next.t('Profile PG Please select country code'),
					});
        } else {
          let temp_country_code = AllCountriesCustomData.find(element => element.code === formData2.country_code);

          const jsonpar = JSON.stringify({
            country_code: temp_country_code.phone_code,
            phone: validation2.values.phone,
            phone_otp: values.phone_otp
          });
          const res = await postRequest('update-phone-profile', jsonpar);
          if (res && res.code === 200) {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));
            setmodal_MobileVerification(false);
            validation3.setValues({
              ...validation3.values,
              phone_otp: '',
            });
          }
          else {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();
        }
      } catch (error) {
        console.error("Error : ", error);
      }

        submit3.disabled = false
        submit3.textContent = i18next.t('Submit')
      } catch (error) {
        console.error('Error : ', error)
      }
    },
  })

  const [StandardModal2, setStandardModal2] = React.useState(false);
  const togStandardModal2 = async () => {
    setStandardModal2(true);
  }

  const [StandardModal3, setStandardModal3] = React.useState(false);
  const [rejectedReason, setRejectedReason] = React.useState("");

  const togStandardModal3 = async (reason) => {
    setStandardModal3(true);
    setRejectedReason(reason);
  }

  const [File, setFile] = useState();
  const [FileName, setFileName] = useState('');
  const saveFile = (e) => {
    if((e.target.files).length > 0) {
      setFile(e.target.files[0]);
      setFileName(e.target.files[0].name);

      var validationRes = checkFileValidation(e.target.files[0]);
      if (!validationRes.status) {
        setFile();
        setFileName('');

        setAlertData((AlertData) => ({
          ...AlertData,
          variant: 'error',
          message: validationRes.msg,
        }));
        resetAlertData();

        return false;
      }
    }
  };

  const validation5 = useFormik({
    enableReinitialize: true,

    initialValues: {
      name: '',
      type: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required(
        i18next.t("Name is required"),
      ),
      type: Yup.string().required(
        i18next.t("Type is required"),
      ),
    }),
    onSubmit: async (values) => {
        try {
          if (FileName === '') {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: 'Please select a document!',
            }));
            return;
          }

          let submit5 = document.getElementById('submit5');
          submit5.disabled = true;
          submit5.textContent = i18next.t('Processing...');

         const formData = new FormData();
          formData.append("name", values.name);
          formData.append("type", values.type);
          formData.append("file", File);
          formData.append("fileName", FileName);

          const res = await postRequestByFormData('upload-tax-document', formData);
          if (res && res.code === 200) {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'success',
              message: res.message,
            }));

            validation5.resetForm();
            setFile(null);
            setFileName('');
            handleLoadGetTaxDocs();
            setStandardModal2(false);
          }
          else {
            setAlertData((AlertData) => ({
              ...AlertData,
              variant: 'error',
              message: res.message,
            }));
          }
          resetAlertData();

          submit5.disabled = false;
          submit5.textContent = i18next.t('Upload');
        
      } catch (error) {
        console.error("Error : ", error);
      }
    }
  });


  const [FilePath, setFilePath] = React.useState('');
  const [DocumnetsTBody, setDocumnetsTBody] = React.useState('');
  const handleT1Body = async (tempData, filepath) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.name}</td>
        <td>{element.type}</td>
        <td><span className={"font-size-14 badge bg-secondary rounded-pill " + (element.status === 'Pending' ? 'badge-soft-warning' : element.status === 'Verified' ? 'badge-soft-success' : 'badge-soft-danger')}>{formatStatus(element.status)}</span></td>
        <td>{formatDate(element.created_at)}</td>
        <td className="text-center">
          <button type="button" className="btn-sm btn btn-primary me-2"> {/* me-2 adds right margin */}
            <a
              rel="noreferrer"
              target="_blank"
              href={`${process.env.REACT_APP_API_URL}${filepath}${element.document}`}
              download={element.document}
              className="text-success"
              title="Download"
            >
              <i className="bx bx-download" style={{ fontSize: '1.2rem', color: 'white' }}></i>
            </a>
          </button>

          {element.status === "Rejected" && (
            <Button 
              type="button" 
              className="btn-sm btn btn-primary"
              onClick={() => togStandardModal3(element.reason)}
              title="View Reason"
            >
              <i className="bx bx-show" style={{ fontSize: '1.2rem', color: 'white' }}></i> {/* Changed icon to 'view' */}
            </Button>
          )}
        </td>

      </tr>
    ));

    setDocumnetsTBody(tempTBody);
  }

  const [DocumnetsTBody1, setDocumnetsTBody1] = React.useState('');
  const handleT1Body1 = async (tempData, filepath) => {
    let tempTBody = tempData.map((element, index) => (
      <tr key={index}>
        <td>{element.name}</td>
        <td>{element.type}</td>
        <td>{element.period}</td>
        <td>{formatDate(element.created_at)}</td>
        <td className="text-center">
          <button type="button" className="btn-sm btn btn-primary">
          <a
            rel="noreferrer"
            target="_blank"
            href={`${process.env.REACT_APP_API_URL}${filepath}${element.document}`}
            download={element.document}
            className="text-success"
            title="Download"
          >
            <i className="bx bx-download" style={{ fontSize: '1.2rem', color : 'white'}}></i>
          </a>
          </button>
        </td>
      </tr>
    ));

    setDocumnetsTBody1(tempTBody);
  }
  
  const handleLoadGetTaxDocs = async () => {
    const res = await getRequest('get-tax-documents');
    if (res && res.code === 200) {
      let userUploadedDocs = res.data.data.filter(item => item.uploaded_by === 'user');
      handleT1Body(userUploadedDocs, res.data.url);

      let adminUploadedDocs = res.data.data.filter(item => item.uploaded_by === 'admin');
      handleT1Body1(adminUploadedDocs, res.data.url);
    }
    else {
      let tempTBody = (<tr>
                        <td colSpan="7" className="text-center">{i18next.t('No records found')}</td>
                      </tr>);

      setDocumnetsTBody(tempTBody);
      setDocumnetsTBody1(tempTBody);
    }
  }



  React.useEffect(() => {
    handleLoadGetAllCountries();
    handleLoadGetTaxDocs();

    const loadGoogleMapsScript = () => {
      if (!window.google) {
        const script = document.createElement("script")
        script.src = `https://maps.googleapis.com/maps/api/js?key=${process.env.REACT_APP_GOOGLE_MAP_API_KEY}&libraries=places` // <-- your API key here
        script.async = true
        document.body.appendChild(script)
        script.addEventListener("load", initAutocomplete)
      } else {
        initAutocomplete()
      }
    }

    const initAutocomplete = () => {
      if (inputRef.current) {
        const autocomplete = new window.google.maps.places.Autocomplete(
          inputRef.current,
          { types: ["geocode"] },
        )

        autocomplete.addListener("place_changed", () => {
          const place = autocomplete.getPlace()

          if (!place.address_components) return

          // Extract details from address_components
          let street = "" // Street name
          let city = ""
          let state = "" // Administrative area level 1 (e.g., California)
          let postal_code = ""
          let country = ""
          for (const component of place.address_components) {
            if (component.types.includes("country")) {
              country = component.long_name
            } else if (component.types.includes("postal_code")) {
              postal_code = component.long_name
            } else if (component.types.includes("locality")) {
              city = component.long_name
            } else if (
              component.types.includes("administrative_area_level_1")
            ) {
              state = component.long_name
            } else if (component.types.includes("sublocality")) {
              street = component.long_name
            } else if (component.types.includes("route")) {
              street = component.long_name
            }
          }

          validation4.setFieldValue("address", place.formatted_address || "")
          validation4.setFieldValue("street", street)
          validation4.setFieldValue("city", city)
          validation4.setFieldValue("state", state)
          validation4.setFieldValue("postal_code", postal_code)
          validation4.setFieldValue("country", country)
        })
      }
    }

    loadGoogleMapsScript()
  }, []);


  const [PreferredLanguage, setPreferredLanguage] = React.useState('sp');
  const onChangePreferredLanguage = (e) => {
    i18next.changeLanguage(e.target.value);
    setPreferredLanguage(e.target.value);
    localStorage.setItem("I18N_LANGUAGE", e.target.value);
  };
  React.useEffect(() => {
    const language = localStorage.getItem("I18N_LANGUAGE");
    if (!language)
    setPreferredLanguage("sp");
    else
    setPreferredLanguage(language);
  }, []);


  return (
    <React.Fragment>
			{AlertData.message !== '' ? <Snackbars variant={AlertData.variant} message={AlertData.message} /> : ''}
      <div className="page-content common-width">
        <Container fluid>
          {/* Render Breadcrumb */}
          <Breadcrumb title={i18next.t('PG title Tokenizedgreen')} breadcrumbItem={i18next.t('PG breadcrumbItem Profile')} />
          <Row>
            <Col xs="12">
              <div className="sidebar">
                <ul>
                  <li><Link to="/dashboard"><i className="bx bx-home-circle"></i> {i18next.t('Menu Dashboard')}</Link></li>
                  {
                    localStorage.getItem("Collaborator")=="true"?
                    <li><Link to="/collaborator"><i className="fas fa-handshake"></i> {i18next.t('Collaborator')}</Link></li>
                    :''
                  }
                  <li><Link to="/wallet"><i className="bx bx-wallet-alt"></i> {i18next.t('Menu My Wallet')}</Link></li>
                  <li><Link to="/properties"><i className="bx bx-shopping-bag"></i> {i18next.t('Menu Browse Property')}</Link></li>
                  <li><Link to="/portfolio"><i className="bx bx-cart-alt"></i> {i18next.t('Menu My Portfolio')}</Link></li>
                  <li><Link to="/claimed-fund"><i className="bx bx-money"></i> {i18next.t('Menu My Claimed Fund')}</Link></li>
                  <li><Link to="/mytransaction"><i className="bx bx-list-ul"></i> {i18next.t('Menu My Transaction')}</Link></li>
                  <li><Link to="/Kyc"><i className="bx bx-user-check"></i> {i18next.t('Menu KYC Verification')}</Link></li>
                  <li><Link to="/twofaauthenticator"><i className="bx bx-key"></i> {i18next.t('Menu 2FA Authenticator')}</Link></li>
                  <li><Link to="/dividends"><i className="bx bx-wallet-alt"></i> {i18next.t('Menu Dividends')}</Link></li>
                </ul>
              </div>
              <div className="contentt">
                <Row>
                  <Col lg="12">
                    <div className="crypto-buy-sell-nav">
                      <Card className="">
                        <CardBody className="p-4">
                          <div className="mb-3 h4 card-title">{i18next.t('Profile PG Profile Update')}</div>
                          <form>
                            <Row>
                              <Col xs="12">
                                <Row>
                                  <Col md="4" xs="12">
                                    <div className="mb-3">
                                      <Label className="form-label">{i18next.t('Profile PG First name')} :</Label>
                                      <Input name="first_name" type="text" placeholder={i18next.t('Profile PG Enter first name')}
                                        onChange={validation1.handleChange}
                                        onBlur={validation1.handleBlur}
                                        value={validation1.values.first_name || ""}
                                        invalid={
                                          validation1.touched.first_name && validation1.errors.first_name ? true : false
                                        }
                                      />
                                      {validation1.touched.first_name && validation1.errors.first_name ? (
                                        <FormFeedback type="invalid">{validation1.errors.first_name}</FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col md="4" xs="12">
                                    <div className="mb-3">
                                      <Label className="form-label">{i18next.t('Profile PG Last name')} :</Label>
                                      <Input name="last_name" type="text" placeholder={i18next.t('Profile PG Enter last name')}
                                        onChange={validation1.handleChange}
                                        onBlur={validation1.handleBlur}
                                        value={validation1.values.last_name || ""}
                                        invalid={
                                          validation1.touched.last_name && validation1.errors.last_name ? true : false
                                        }
                                      />
                                      {validation1.touched.last_name && validation1.errors.last_name ? (
                                        <FormFeedback type="invalid">{validation1.errors.last_name}</FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col md="4" xs="12">
                                    <div className="mb-3">
                                      <Label className="form-label">{i18next.t('Profile PG Email')} :</Label>
                                      <Input type="email" placeholder={i18next.t('Profile PG Enter email')} readOnly
                                        name="email"
                                        value={validation1.values.email || ""}
                                      />
                                    </div>
                                  </Col>
                                  <Col md="4" xs="12">
                                    <div className="mb-3 Register-Select2">
                                      <Label className="form-label">{i18next.t('Profile PG Select country')} :</Label>
                                      <Select styles={colourStyles} value={formData1.country} onChange={(e) => setFormData1({ ...formData1, country: e })} options={AllCountriesCustomData2} classNamePrefix="select2-selection" />
                                      {CustomError1.country !== '' ? (<FormFeedback type="invalid" style={{ display: 'block' }}>{CustomError1.country}</FormFeedback>
                                      ): null}
                                    </div>
                                  </Col>
                                  {/* <Col md="4" xs="12">
                                    <div className="mb-3">
                                      <Label className="form-label">{i18next.t('Profile PG Profile picture')} :</Label>
                                      <Input type="file" placeholder="" className="fileUpload" id="formFile" />
                                    </div>
                                  </Col> */}
                                  <Col md="4" xs="12">
                                    <div className="mb-3">
                                      <Label className="form-label">{i18next.t('Profile PG Select preferred language')} :</Label>
                                      <select className="form-select" name="preferred_language" value={PreferredLanguage} onChange={(e) => onChangePreferredLanguage( e )}>
                                        <option value={'eng'}>English</option>
                                        <option value={'sp'}>Spanish</option>
                                      </select>
                                      {CustomError1.preferred_language !== '' ? (<FormFeedback type="invalid" style={{ display: 'block' }}>{CustomError1.preferred_language}</FormFeedback>
                                      ): null}
                                    </div>
                                  </Col>
                                </Row>
                              </Col>                              
                            </Row>
                          </form>
                          <div className="text-left">
                            <Button type="button" color="primary"
                              id="submit1"
                              onClick={(e) => {
                                e.preventDefault();
                                validation1.handleSubmit();
                                return false;
                              }}
                          >{i18next.t('Profile PG Update Profile')}</Button>
                          </div>
                        </CardBody>
                      </Card>

                      <Card className="">
                        <CardBody className="p-4">
                          <div className="mb-3 h4 card-title">{i18next.t('Profile PG Mobile Number')}</div>
                          <form>
                              <div>
                                <Col xs="12">
                                  <div className="mb-3 countryBox">
                                    <div className="row">
                                      <div className="col-md-3">
                                        {/* <Autocomplete
                                            value={formData2.country_code}
                                            onChange={(event, newValue) => {
                                              setFormData2({ ...formData2, country_code: newValue })
                                            }}
                                            id="country-code"
                                            options={AllCountriesCustomData}
                                            getOptionLabel={(option) => option.title}
                                            renderOption={(option) => (
                                                <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }}>
                                                <img
                                                    loading="lazy"
                                                    width="20"
                                                    src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                                                    srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                                                    alt={option.code}
                                                />
                                                &nbsp;{option.title}
                                                </Box>
                                            )}
                                            renderInput={(params) => <TextField {...params} variant="outlined" />}
                                        /> */}
                                        <ReactFlagsSelect
                                          placeholder={i18next.t('Profile PG Select country code')}
                                          countries={AllCountriesCustomData.map(country => country.code)}
                                          customLabels={AllCountriesCustomData.reduce((acc, country) => {
                                            acc[country.code] = country.label;
                                            return acc;
                                          }, {})}
                                          name="country_code" selected={formData2.country_code} onSelect={(e) => setFormData2({ ...formData2, country_code: e })}
                                        />
                                        {CustomError2.country_code !== '' ? (<FormFeedback type="invalid" style={{ display: 'block' }}>{CustomError2.country_code}</FormFeedback>
                                        ): null}
                                      </div>
                                      <div className="col-md-4">
                                        <Input type="text" placeholder={i18next.t('Profile PG Enter new mobile number')}
                                          name="phone"
                                          onChange={validation2.handleChange}
                                          onBlur={validation2.handleBlur}
                                          value={validation2.values.phone || ""}
                                          invalid={
                                            validation2.touched.phone && validation2.errors.phone ? true : false
                                          }
                                        />
                                        {validation2.touched.phone && validation2.errors.phone ? (
                                          <FormFeedback type="invalid">{validation2.errors.phone}</FormFeedback>
                                        ) : null}
                                      </div>
                                    </div>
                                  </div>
                                </Col>
                                <Button className="centerBtn" type="button" color="primary"
                                  id="submit2"
                                  // onClick={(e) => MobileVerification()}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    validation2.handleSubmit();
                                    return false;
                                  }}
                                > {i18next.t('Update')} </Button>
                              </div>
                         
                          </form>
                        </CardBody>
                      </Card>

                      <Card className="">
                        <CardBody className="p-4">
                          <div className="mb-3 h4 card-title">{i18next.t('Tax Information')}</div>
                          <form>
                              <div>
                                <Col xs="12">
                                <Row>
                                 <Col md="4" xs="12">
                                    <div className="mb-3 Register-Select2">
                                      <Label className="form-label">{i18next.t('Select tax residency')} :</Label>
                                      <Select styles={colourStyles} value={formData4.tax_residency} onChange={(e) => setFormData4({ ...formData4, tax_residency: e })} options={AllCountriesCustomData2} classNamePrefix="select2-selection" />
                                      {CustomError4.tax_residency !== '' ? (<FormFeedback type="invalid" style={{ display: 'block' }}>{CustomError4.tax_residency}</FormFeedback>
                                      ): null}
                                    </div>
                                  </Col>
                                  <Col md="4" xs="12">
                                    <div className="mb-3">
                                      <Label className="form-label">{i18next.t('Tax ID')} :</Label>
                                      <Input name="tax_id" type="text" placeholder={i18next.t('Enter Tax ID')}
                                        onChange={validation4.handleChange}
                                        onBlur={validation4.handleBlur}
                                        value={validation4.values.tax_id || ""}
                                        invalid={
                                          validation4.touched.tax_id && validation4.errors.tax_id ? true : false
                                        }
                                      />
                                      {validation4.touched.tax_id && validation4.errors.tax_id ? (
                                        <FormFeedback type="invalid">{validation4.errors.tax_id}</FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                  <Col md="4" xs="12">
                                    <div className="mb-3">
                                      <Label className="form-label">
                                        {i18next.t("Date of Birth")} :
                                      </Label>
                                      <Input
                                        name="date_of_birth"
                                        type="date" // ✅ Datepicker
                                        onChange={validation4.handleChange}
                                        onBlur={validation4.handleBlur}
                                        value={validation4.values.date_of_birth || ""}
                                        invalid={
                                          validation4.touched.date_of_birth &&
                                          validation4.errors.date_of_birth
                                            ? true
                                            : false
                                        }
                                      />
                                      {validation4.touched.date_of_birth &&
                                      validation4.errors.date_of_birth ? (
                                        <FormFeedback type="invalid">
                                          {validation4.errors.date_of_birth}
                                        </FormFeedback>
                                      ) : null}
                                    </div>
                                  </Col>
                                   <Col md="4" xs="12">
                                      <div className="mb-3">
                                        <Label className="form-label">
                                          {i18next.t("Address")} :
                                        </Label>
                                        <input
                                          type="text"
                                          ref={inputRef} // <-- NEW: attach Google Autocomplete
                                          name="address"
                                          placeholder={i18next.t("Enter Address")}
                                          className={`form-control ${validation4.touched.address && validation4.errors.address ? "is-invalid" : ""}`}
                                          onChange={validation4.handleChange} // <-- NEW: update Formik state manually if user types
                                          onBlur={validation4.handleBlur} // <-- NEW: validate Formik field
                                          value={validation4.values.address} // <-- NEW: show selected value
                                        />
                                        {validation4.touched.address &&
                                          validation4.errors.address && (
                                            <FormFeedback type="invalid">
                                              {validation4.errors.address}
                                            </FormFeedback>
                                          )}
                                      </div>
                                    </Col>
                                    <Col md="4" xs="12">
                                      <div className="mb-3">
                                        <Label className="form-label">
                                          {i18next.t("Building")} :
                                        </Label>
                                        <input
                                          type="text"
                                          name="building"
                                          placeholder={i18next.t("Building")}
                                          className={`form-control ${validation4.touched.building && validation4.errors.building ? "is-invalid" : ""}`}
                                          onChange={validation4.handleChange}
                                          onBlur={validation4.handleBlur}
                                          value={validation4.values.building}
                                        />
                                        {validation4.touched.building &&
                                          validation4.errors.building && (
                                            <FormFeedback type="invalid">
                                              {validation4.errors.building}
                                            </FormFeedback>
                                          )}
                                      </div>
                                    </Col>
                                    <Col md="4" xs="12">
                                      <div className="mb-3">
                                        <Label className="form-label">
                                          {i18next.t("Floor1")}
                                        </Label>
                                        <input
                                          type="text"
                                          name="floor"
                                          placeholder={i18next.t("Floor1")}
                                          className={`form-control ${validation4.touched.floor && validation4.errors.floor ? "is-invalid" : ""}`}
                                          onChange={validation4.handleChange}
                                          onBlur={validation4.handleBlur}
                                          value={validation4.values.floor}
                                        />
                                        {validation4.touched.floor &&
                                          validation4.errors.floor && (
                                            <FormFeedback type="invalid">
                                              {validation4.errors.floor}
                                            </FormFeedback>
                                          )}
                                      </div>
                                    </Col>
                                  </Row>
                                </Col>
                                <Button className="centerBtn" type="button" color="primary"
                                  id="submit4"
                                  // onClick={(e) => MobileVerification()}
                                  onClick={(e) => {
                                    e.preventDefault();
                                    validation4.handleSubmit();
                                    return false;
                                  }}
                                > {i18next.t('Update')} </Button>
                              </div>
                         
                          </form>
                        </CardBody>
                      </Card>

                      <Card className="">
                        <CardBody className="p-4">
                          <div className="d-flex justify-content-between align-items-center mb-3">
                            <div className="h4 card-title mb-0">
                              {i18next.t('Tax Documents')}
                            </div>
                          </div>

                          <div className="d-flex justify-content-between align-items-center mb-3" style={{ marginLeft: '20px' }}>
                            <div className="text-muted" style={{ fontSize: '0.95rem', fontWeight: 'bold' }}>
                              {i18next.t('Uploaded By User')}
                            </div>
                            <Button className="btn btn-success btn-sm me-3" color="primary" onClick={(e)=>togStandardModal2()}>
                              {i18next.t('Upload New')}
                            </Button>
                          </div>
                          <Row>
                            <Col lg="12">
                              <div className="card">
                                <div className="card-body">
                                  <div className="table-responsive">
                                    <table className="table mb-0" style={{minWidth: '1000px'}}>
                                      <thead className="table-light">
                                        <tr>
                                          <th>{i18next.t('Name')}</th>
                                          <th>{i18next.t('Type')}</th>
                                          <th>{i18next.t('Status')}</th>
                                          <th>{i18next.t('Uploaded On')}</th>
                                          <th className="text-center">{i18next.t('Action')}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {DocumnetsTBody}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>

                          <div
                            className="text-muted mb-3"
                            style={{ fontSize: '0.95rem', marginLeft: '20px', fontWeight: 'bold' }}
                          >
                            {i18next.t('Provided By Tokenized Green')}
                          </div>                          
                          <Row>
                            <Col lg="12">
                              <div className="card">
                                <div className="card-body">
                                  <div className="table-responsive">
                                    <table className="table mb-0" style={{minWidth: '1000px'}}>
                                      <thead className="table-light">
                                        <tr>
                                          <th>{i18next.t('Name')}</th>
                                          <th>{i18next.t('Type')}</th>
                                          <th>{i18next.t('Period')}</th>
                                          <th>{i18next.t('Issued On')}</th>
                                          <th className="text-center">{i18next.t('Action')}</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        {DocumnetsTBody1}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </Col>
                          </Row>

                        </CardBody>
                      </Card>


                      <Card>
                        <CardBody>
                          <div className="text-left">
                            {/* Marketing consent toggle — Step 2.2 */}
                            <div className="mb-3 h4 card-title">{i18next.t('Profile PG Email communications title')}</div>
                            <div
                              className="d-flex align-items-center mb-2"
                              style={{ cursor: consentLoading ? 'not-allowed' : 'pointer' }}
                              onClick={() => { if (!consentLoading) handleConsentToggle(!marketingConsent); }}
                            >
                              {/* Custom switch — pure onClick, no reliance on checkbox onChange */}
                              <div
                                style={{
                                  width: 44,
                                  height: 24,
                                  borderRadius: 12,
                                  background: marketingConsent ? '#036B41' : '#ccc',
                                  position: 'relative',
                                  transition: 'background 0.2s',
                                  flexShrink: 0,
                                  opacity: consentLoading ? 0.6 : 1,
                                }}
                              >
                                <div
                                  style={{
                                    width: 18,
                                    height: 18,
                                    borderRadius: '50%',
                                    background: '#fff',
                                    position: 'absolute',
                                    top: 3,
                                    left: marketingConsent ? 23 : 3,
                                    transition: 'left 0.2s',
                                  }}
                                />
                              </div>
                              <span className="ms-3" style={{ fontWeight: 500 }}>
                                {i18next.t('Profile PG Email communications label')}
                              </span>
                            </div>
                            <small className="text-muted">
                              {i18next.t('Profile PG Email communications helper')}
                            </small>
                          </div>
                        </CardBody>
                      </Card>
                    </div>

                  </Col>
                </Row>

              </div>
            </Col>
          </Row>


        </Container>
      </div>


      {/* Mobile Verify */}

      <Modal isOpen={modal_MobileVerification} toggle={() => { MobileVerification(); }} backdrop={'static'} centered className="transation">
        <div className="modal-header">
          <h5 className="modal-title mt-0">Phone Number Verification</h5>
          <button type="button" onClick={() => { setmodal_MobileVerification(false); }} className="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true" onClick={refreshPage}>&times;</span>
          </button>
        </div>

        <div className='modal-body'>
            <Col md={12}>
              <div className='mb-4'>
                <Label className="form-label">{i18next.t('Email_Verification PG Phone OTP')} :</Label>
                <Input
                  name="phone_otp"
                  type="text"
                  placeholder={i18next.t(
                    'Email_Verification PG Enter Phone OTP',
                  )}
                  onChange={validation3.handleChange}
                  onBlur={validation3.handleBlur}
                  value={validation3.values.phone_otp || ''}
                  invalid={
                    validation3.touched.phone_otp && validation2.errors.phone_otp ? true : false
                  }
                />
                {validation3.touched.phone_otp && validation3.errors.phone_otp ? (
                  <FormFeedback type="invalid">{validation3.errors.phone_otp}</FormFeedback>
                ) : null}
              </div>
            </Col>

            <Button id="submit3"
              onClick={(e) => {
                e.preventDefault();
                validation3.handleSubmit();
                return false;
              }}
              className='btn btn-primary mb-2'>
              {i18next.t('Update')}
            </Button>
          </div>
      </Modal>

      <Modal className="transation" centered backdrop="static" isOpen={StandardModal2}>
        <div className="modal-header">
          <h5 className="modal-title mt-0">{i18next.t('Upload Document')}</h5>
          <button type="button" onClick={(e)=>setStandardModal2(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col xs={12}>
            <div className="mb-3">
              <label className="form-label">{i18next.t('Name')} :</label>
              <Input 
                name="name" 
                type="text" 
                placeholder={i18next.t('Enter Name')}
                onChange={validation5.handleChange}
                onBlur={validation5.handleBlur}
                value={validation5.values.name|| ""}
                invalid={
                  validation5.touched.name && validation5.errors.name ? true : false
                }
              />
              {validation5.touched.name && validation5.errors.name ? (
                <FormFeedback type="invalid">{validation5.errors.name}</FormFeedback>
              ) : null}
            </div>

            <div className="mb-3">
              <label className="form-label">{i18next.t('Type')} :</label>
              <Input 
                name="type" 
                type="text" 
                placeholder={i18next.t('Enter Type')}
                onChange={validation5.handleChange}
                onBlur={validation5.handleBlur}
                value={validation5.values.type|| ""}
                invalid={
                  validation5.touched.type && validation5.errors.type ? true : false
                }
              />
              {validation5.touched.type && validation5.errors.type ? (
                <FormFeedback type="invalid">{validation5.errors.type}</FormFeedback>
              ) : null}
            </div>

             <div className="mb-3">
                <label className="form-label">{i18next.t('Document')} : </label>
                <Input
                  type="file"
                  className="form-control"
                  onChange={saveFile}
                  accept=".pdf,.jpg,.jpeg,.png"
                />
              
              </div>
          </Col>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-primary"
            id="submit5"
            onClick={(e) => {
              e.preventDefault();
              validation5.handleSubmit();
              return false;
            }}
          > {i18next.t('Upload')} </button>
          <button type="button" className="btn btn-light" data-dismiss="modal" onClick={(e)=>setStandardModal2(false)} aria-label="Close">{i18next.t('Close')}</button>
        </div>
      </Modal>

      <Modal className="transation" centered backdrop="static" isOpen={StandardModal3}>
        <div className="modal-header">
          <h3 className="modal-title mt-0">{i18next.t('Rejected Reason')}</h3>
          <button type="button" onClick={(e)=>setStandardModal3(false)} className="close" data-dismiss="modal" aria-label="Close" >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <Col xs={12}>
             <div className="mb-3">
                  <textarea
                    className="form-control"
                    name="reason"
                    value={rejectedReason || ""}
                    disabled
                  >
                  </textarea>
              </div>
          </Col>
        </div>
       
      </Modal>
    </React.Fragment>
  );
};

export default withRouter(UserProfile);
